import { render, staticRenderFns } from "./zbtg.vue?vue&type=template&id=3d425076&"
import script from "./zbtg.vue?vue&type=script&lang=js&"
export * from "./zbtg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports